import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ContentDataService {

  constructor(private http: HttpClient) { }

  getFAQ(): Observable<any> {
    return this.http.get<ApiResponse>('/faq?paginate=false&sort_by=position&sort_order=asc').pipe(
      map(res => res.data)
    );
  }

  getAboutUs(): Observable<any> {
    return this.http.get<ApiResponse>('/aboutus?paginate=false&sort_by=position&sort_order=asc').pipe(
      map(res => res.data)
    );
  }

  getTermsConditions(): Observable<any> {
    return this.http.get<ApiResponse>('/termsandconditions?paginate=false&sort_by=position&sort_order=asc').pipe(
      map(res => res.data)
    );
  }

  getPrivacyPolicy(): Observable<any> {
    return this.http.get<ApiResponse>('/privacypolicy?paginate=false&sort_by=position&sort_order=asc').pipe(
      map(res => res.data)
    );
  }

  getResponsibleGaming(): Observable<any> {
    return this.http.get<ApiResponse>('/responsiblegaming?paginate=false&sort_by=position&sort_order=asc').pipe(
      map(res => res.data)
    );
  }
}
